<template>
    <nav class="navbar primary navbar-expand-lg">
      <div class="container">
        <div class="navbar-wrapper primary">
          <div class="wrapper-inner">
            <div class="navbar-breadcrumb">
              <ul class="breadcrumb">
                <li class="breadcrumb-item" v-for="(crumb, index) in breadcrumbs" :key="index">
                  <router-link 
                    :to="crumb.url" 
                    :class="['link-breadcrumb', { 'active': crumb.active }]"
                  >
                    {{ crumb.text }}
                  </router-link>
                </li>
              </ul>
            </div>
          </div>
          <div class="wrapper-inner">
            <ul class="navbar-nav primary">
              <li class="nav-item">
                <a class="nav-icon" href="javascript:void(0);" @click="storeDarkMode({darkMode:!darkMode})">
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.74525 2C6.37519 2 2.33112 5.37006 2.33112 10.7622C2.33112 16.1542 6.37519 20.1983 11.7673 20.1983C17.1594 20.1983 20.5294 16.1542 20.5294 12.7842C13.1153 17.5023 5.02716 9.41413 9.74525 2Z" stroke="#9D9FA3" stroke-width="1.69446" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </a>
              </li>
              <li class="nav-item dropdown notification-dropdown" v-if="false">
                <a class="nav-icon notification-icon" href="javascript:void(0);" @click.stop="toggleNotificationDropdown" ref="notificationToggle">
                  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11 2C7.13401 2 4 5.13401 4 9V13L2 15V16H20V15L18 13V9C18 5.13401 14.866 2 11 2Z" stroke="#9D9FA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M8 16V17C8 18.6569 9.34315 20 11 20C12.6569 20 14 18.6569 14 17V16" stroke="#9D9FA3" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <span class="notification-badge" v-if="unreadNotificationsCount > 0">{{ unreadNotificationsCount }}</span>
                </a>
                <ul class="dropdown-menu notification-menu" :class="{ 'show': isNotificationDropdownOpen }" ref="notificationMenu">
                  <li class="notification-header">
                    <h4>Notificações</h4>
                    <button class="btn-mark-all-read" v-if="unreadNotificationsCount > 0" @click="markAllAsRead">Marcar todas como lidas</button>
                  </li>
                  <li class="notification-item" 
                      v-for="notification in notifications" 
                      :key="notification.id"
                      :class="{ 'unread': !notification.read }"
                      @click="handleNotificationClick(notification)">
                    <div class="notification-icon-wrapper" :class="notification.type">
                      <i :class="notification.icon"></i>
                    </div>
                    <div class="notification-content">
                      <div class="notification-title">{{ notification.title }}</div>
                      <div class="notification-message">{{ notification.message }}</div>
                      <div class="notification-time">{{ notification.time }}</div>
                    </div>
                    <button class="btn-close-notification" @click.stop="removeNotification(notification.id)">
                      <i class="fas fa-times"></i>
                    </button>
                  </li>
                  <li class="notification-empty" v-if="notifications.length === 0">
                    <p>Nenhuma notificação</p>
                  </li>
                </ul>
              </li>
              <li class="nav-item dropdown user-avatar">
                <a class="nav-link dropdown-toggle"  @click.stop="toggleDropdown" ref="dropdownToggle">
                  <img v-if="user && user.image64" :src="user.image64" alt="Foto do usuário" class="user-image" />
                  <span v-else>{{ getUserInitials() }}</span>
                </a>
                <ul class="dropdown-menu" :class="{ 'show': isDropdownOpen }" ref="dropdownMenu">
                  <li class="dropdown-item" >
                    <router-link 
                      :to="'/dashboard/editar-usuario/' + (user?.id || '')" 
                      :class="'link-dropdown'"
                    >
                      {{ 'Perfil' }}
                    </router-link>
                  </li>
                  <li class="dropdown-item" v-for="(item, index) in dropdownItems" :key="index">
                    <router-link 
                      :to="item.url" 
                      :class="item.isButton ? 'btn btn-block btn-dropdown' : 'link-dropdown'"
                    >
                      {{ item.text }}
                    </router-link>
                  </li>
                 
                  <li class="dropdown-item">
                    <a data-v-021887fb=""  class="btn btn-block btn-dropdown" @click="logout">Sair</a>
                  </li>
                </ul>
              </li>
              <li class="nav-item">
                <a class="nav-toggle" @click.prevent="toggleSidebar">
                  <i class="fas fa-bars"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </nav>
    <Loader :loading="isLoading" />
  </template>
  
<script>
  import { mapState, mapActions } from 'vuex';
  import Loader from './Loader.vue';
  import Login from '../utils/login';

  export default {
    name: 'Toolbar',
    components: {
      Loader
    },

    data() {
      return {
        isDropdownOpen: false,
        isNotificationDropdownOpen: false,
        isLoading: false,
        dropdownItems: [
          { text: 'Configurações', url: '/dashboard/configuracao', isButton: false },
        ],
        notifications: [
          {
            id: 1,
            type: 'warning',
            icon: 'fas fa-exclamation-triangle',
            title: 'Boleto próximo ao vencimento',
            message: 'Seu boleto vence em 3 dias. Valor: R$ 79,90',
            time: 'há 2 horas',
            read: false,
            action: '/dashboard/financeiro'
          },
          {
            id: 2,
            type: 'danger',
            icon: 'fas fa-hdd',
            title: 'Armazenamento próximo ao limite',
            message: 'Você está usando 85% do seu espaço (42.5 GB de 50 GB)',
            time: 'há 5 horas',
            read: false,
            action: '/dashboard/financeiro'
          },
          {
            id: 3,
            type: 'danger',
            icon: 'fas fa-exclamation-circle',
            title: 'Espaço crítico! 99% de uso',
            message: 'Seu armazenamento está quase no limite! Você está usando 99% (49.5 GB de 50 GB). Considere fazer upgrade do plano.',
            time: 'há 1 hora',
            read: false,
            action: '/dashboard/financeiro'
          }
        ],
        storageUsage: 0,
        storageLimit: 0,
        bandwidthUsage: 0
      };
    },

    computed: {
      ...mapState(['user', 'darkMode', 'breadcrumbs', 'token', 'activeSidebar', 'account']),
      unreadNotificationsCount() {
        return this.notifications.filter(n => !n.read).length;
      }
    },

    methods: {
      ...mapActions(['storeDarkMode', 'clearAuth', 'storeActiveSidebar']),

      toggleSidebar() {
        const aux = !this.activeSidebar;
        this.storeActiveSidebar({ activeSidebar: aux });
      },

      toggleDropdown() {
        this.isDropdownOpen = !this.isDropdownOpen;
        if (this.isDropdownOpen) {
          this.isNotificationDropdownOpen = false;
        }
      },

      toggleNotificationDropdown() {
        this.isNotificationDropdownOpen = !this.isNotificationDropdownOpen;
        if (this.isNotificationDropdownOpen) {
          this.isDropdownOpen = false;
        }
      },

      handleClickOutside(event) {
        const dropdown = this.$refs.dropdownMenu;
        const toggle = this.$refs.dropdownToggle;
        const notificationMenu = this.$refs.notificationMenu;
        const notificationToggle = this.$refs.notificationToggle;

        if (
          dropdown &&
          toggle &&
          !dropdown.contains(event.target) &&
          !toggle.contains(event.target)
        ) {
          this.isDropdownOpen = false;
        }

        if (
          notificationMenu &&
          notificationToggle &&
          !notificationMenu.contains(event.target) &&
          !notificationToggle.contains(event.target)
        ) {
          this.isNotificationDropdownOpen = false;
        }
      },

      handleNotificationClick(notification) {
        if (!notification.read) {
          notification.read = true;
        }
        if (notification.action) {
          this.$router.push(notification.action);
          this.isNotificationDropdownOpen = false;
        }
      },

      removeNotification(id) {
        this.notifications = this.notifications.filter(n => n.id !== id);
      },

      markAllAsRead() {
        this.notifications.forEach(n => n.read = true);
      },

      async checkNotifications() {
        // Buscar dados do dashboard para atualizar notificações
        try {
          const dashboard = await import('@/utils/dashboard');
          const response = await dashboard.default.getInfoDashboard(this.token);
          const data = response.data.data;
          
          this.storageUsage = data.storageUsage || 0;
          this.bandwidthUsage = data.bandwidthUsage || 0;
          
          // Obter storageLimit da account se disponível
          if (this.account) {
            const plan = this.account.plan || this.account.subscription || {};
            this.storageLimit = plan.storageLimit || this.account.storageLimit || (50 * 1024 * 1024 * 1024);
          } else {
            // Valor padrão se não houver account
            this.storageLimit = 50 * 1024 * 1024 * 1024;
          }
          
          // Atualizar notificações baseado nos dados reais (mas manter as mockadas)
          this.updateNotifications();
        } catch (error) {
          console.error('Erro ao buscar dados para notificações:', error);
          // Usar valores padrão em caso de erro, mas manter notificações mockadas
          this.storageLimit = 50 * 1024 * 1024 * 1024;
          // Não atualizar notificações em caso de erro, mantém as mockadas
        }
      },

      updateNotifications() {
        // Por enquanto, não atualiza notificações para preservar as mockadas
        // Quando a API estiver disponível, pode descomentar e usar esta função
        // para atualizar os valores dinamicamente
        
        // if (this.storageLimit > 0 && this.storageUsage > 0) {
        //   const usagePercentage = (this.storageUsage / this.storageLimit) * 100;
        //   
        //   // Atualizar notificação de 85% se existir
        //   const storageNotification85 = this.notifications.find(n => n.id === 2);
        //   if (storageNotification85) {
        //     if (usagePercentage >= 80 && usagePercentage < 95) {
        //       storageNotification85.message = `Você está usando ${usagePercentage.toFixed(1)}% do seu espaço (${this.formatBytes(this.storageUsage)} de ${this.formatBytes(this.storageLimit)})`;
        //       storageNotification85.read = false;
        //     }
        //   }
        //
        //   // Atualizar notificação de 99% se existir
        //   const storageNotification99 = this.notifications.find(n => n.id === 3);
        //   if (storageNotification99) {
        //     if (usagePercentage >= 95) {
        //       storageNotification99.message = `Seu armazenamento está quase no limite! Você está usando ${usagePercentage.toFixed(1)}% (${this.formatBytes(this.storageUsage)} de ${this.formatBytes(this.storageLimit)}). Considere fazer upgrade do plano.`;
        //       storageNotification99.read = false;
        //     }
        //   }
        // }
      },

      formatBytes(bytes) {
        if (!bytes) return '0 B';
        const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
        const i = Math.floor(Math.log(bytes) / Math.log(1024));
        return `${(bytes / Math.pow(1024, i)).toFixed(2)} ${sizes[i]}`;
      },

      getUserInitials() {
        if (!this.user || !this.user.firstName || !this.user.lastName) {
          return 'U';
        }
        return `${this.user.firstName[0]} ${this.user.lastName[0]}`;
      },

      async logout() {
        this.isLoading = true;
        try {
          this.clearAuth();
          this.$router.push('/');
        } catch (error) {
          console.error('Erro ao fazer logout:', error);
        } finally {
          this.isLoading = false;
        }
      }
    },

    mounted() {
      document.addEventListener('click', this.handleClickOutside);
      // Não buscar dados automaticamente para preservar notificações mockadas
      // Se quiser atualizar com dados reais, descomente abaixo:
      // if (this.token) {
      //   this.checkNotifications();
      // }
    },
    watch: {
      // Comentado para preservar notificações mockadas
      // account: {
      //   handler(newAccount) {
      //     if (newAccount && this.token) {
      //       this.checkNotifications();
      //     }
      //   },
      //   immediate: true
      // }
    },

    beforeUnmount() {
      document.removeEventListener('click', this.handleClickOutside);
    }
  };
</script>
<style lang="scss" scoped>
  .navbar-nav.primary {
    gap: 1.5rem;
    display: flex;
    align-items: center;
  }

  .navbar-nav.primary .nav-item {
    margin: 0;
    display: flex;
    align-items: center;
  }

  .navbar-nav.primary .nav-item:not(:last-child) {
    margin-right: 0.75rem;
  }

  .navbar-nav.primary .nav-item .nav-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
    transition: opacity 0.2s ease;
    cursor: pointer;
  }

  .navbar-nav.primary .nav-item .nav-icon:hover {
    opacity: 0.7;
  }

  .notification-dropdown {
    margin-right: 0;
  }

  .notification-icon {
    position: relative;
  }

  li.nav-item.dropdown.user-avatar {
    padding: 5px;
    background-color: #f5870f;
    border-radius: 50%;
    position: relative;
    cursor: pointer;
    margin-left: 0.75rem;
  }
  li.nav-item.dropdown.user-avatar a{
    color: #fff;
  }
  .user-image {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    object-fit: cover;
  }
  .dropdown-menu {
    display: none;
    position: absolute;
    right: 0;
    top: 100%;
    min-width: 200px;
    background: white;
    box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    border-radius: 4px;
    padding: 8px 0;
  }
  .dropdown-menu.show {
    display: block;
  }
  .dropdown-item {
    padding: 8px 16px;
  }
  .dropdown-item:hover {
    background-color: #f8f9fa;
  }
  .btn-dropdown {
    width: 100%;
    text-align: left;
    background: none;
    border: none;
    color: #dc3545;
  }
  .notification-dropdown {
    position: relative;
  }

  .notification-icon {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .notification-badge {
    position: absolute;
    top: -4px;
    right: -4px;
    background-color: #F44336;
    color: #ffffff;
    border-radius: 50%;
    width: 18px;
    height: 18px;
    font-size: 10px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #ffffff;
  }

  .notification-menu {
    min-width: 350px;
    max-width: 400px;
    max-height: 500px;
    overflow-y: auto;
    right: 0;
    left: auto;
    padding: 0;
  }

  .notification-header {
    padding: 1rem;
    border-bottom: 1px solid #eeeeee;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0;
    background-color: #ffffff;
    z-index: 10;

    h4 {
      margin: 0;
      font-size: 1.1rem;
      font-weight: 600;
      color: #333;
    }

    .btn-mark-all-read {
      background: none;
      border: none;
      color: #F5870F;
      font-size: 0.85rem;
      cursor: pointer;
      padding: 0.25rem 0.5rem;
      border-radius: 0.25rem;
      transition: background-color 0.2s ease;

      &:hover {
        background-color: rgba(245, 135, 15, 0.1);
      }
    }
  }

  .notification-item {
    padding: 1rem;
    border-bottom: 1px solid #f0f0f0;
    display: flex;
    gap: 1rem;
    cursor: pointer;
    transition: background-color 0.2s ease;
    position: relative;

    &:hover {
      background-color: #f8f9fa;
    }

    &.unread {
      background-color: rgba(245, 135, 15, 0.05);
      border-left: 3px solid #F5870F;
    }

    .notification-icon-wrapper {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;

      &.warning {
        background-color: rgba(255, 152, 0, 0.1);
        color: #FF9800;
      }

      &.danger {
        background-color: rgba(244, 67, 54, 0.1);
        color: #F44336;
      }

      &.info {
        background-color: rgba(33, 150, 243, 0.1);
        color: #2196F3;
      }

      i {
        font-size: 1.1rem;
      }
    }

    .notification-content {
      flex: 1;
      min-width: 0;

      .notification-title {
        font-weight: 600;
        color: #333;
        margin-bottom: 0.25rem;
        font-size: 0.95rem;
      }

      .notification-message {
        color: #666;
        font-size: 0.85rem;
        margin-bottom: 0.25rem;
        line-height: 1.4;
      }

      .notification-time {
        color: #999;
        font-size: 0.75rem;
      }
    }

    .btn-close-notification {
      background: none;
      border: none;
      color: #999;
      cursor: pointer;
      padding: 0.25rem;
      opacity: 0;
      transition: opacity 0.2s ease, color 0.2s ease;
      flex-shrink: 0;

      &:hover {
        color: #F44336;
      }
    }

    &:hover .btn-close-notification {
      opacity: 1;
    }
  }

  .notification-empty {
    padding: 2rem;
    text-align: center;
    color: #999;

    p {
      margin: 0;
    }
  }

  .dark-mode {
    .notification-header {
      background-color: #201F24;
      border-bottom-color: #282b30;

      h4 {
        color: #ffffff;
      }
    }

    .notification-item {
      border-bottom-color: #282b30;

      &:hover {
        background-color: #282b30;
      }

      &.unread {
        background-color: rgba(245, 135, 15, 0.1);
      }

      .notification-content {
        .notification-title {
          color: #ffffff;
        }

        .notification-message {
          color: #cccccc;
        }
      }
    }

    .notification-empty {
      color: #999;
    }
  }

  @media (max-width: 768px) {
    .notification-menu {
      min-width: 300px;
      max-width: calc(100vw - 2rem);
    }

    .dark-mode .navbar.primary {
      box-shadow: 20px 0px 10px 3px #000000;
      z-index: 1;
    }
    .navbar.primary {
      box-shadow: 20px 0px 10px 3px #a9a9a9;
      z-index: 1;
    }
  }
  </style>